import { render, staticRenderFns } from "./BindingDoorphone.vue?vue&type=template&id=097b5cc8&scoped=true"
import script from "./BindingDoorphone.vue?vue&type=script&lang=js"
export * from "./BindingDoorphone.vue?vue&type=script&lang=js"
import style0 from "./BindingDoorphone.vue?vue&type=style&index=0&id=097b5cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b5cc8",
  null
  
)

export default component.exports